import { trackPromise } from 'react-promise-tracker';
import { api } from '../../../../../../lib';
import { CampaignTypeResponse } from '../lib/types';

export interface CampaignConfig {
  priority: 'PRIORITY_TYPE' | 'PRICE_LOWER';
  editOffer: boolean;
}

// CONFIGURACAO
export const getCampaignSetup = () => {
  return trackPromise(
    api({
      url: `${process.env.REACT_APP_IPA_URL}/setup/campaign`,
      method: 'GET',
      expectToken: true,
    }).then(response => response.data),
    '',
  );
};

export async function upsertCampaignSetup(payload: CampaignConfig): Promise<void> {
  return trackPromise(
    api({
      url: `${process.env.REACT_APP_IPA_URL}/setup/campaign`,
      method: 'POST',
      data: payload,
      expectToken: true,
    }).then(response => response.data),
    '',
  );
}

// CAMPANHA
export const getCampaignTypes = (): Promise<CampaignTypeResponse[]> => {
  return trackPromise(
    api({
      url: `${process.env.REACT_APP_IPA_URL}/campaign/type`,
      method: 'GET',
      expectToken: true,
    }).then(response => response.data),
    '',
  );
};

export const changeCampaignTypeOrder = ({ firstId, secondId }: { firstId: string; secondId: string }) => {
  return trackPromise(
    api({
      url: `${process.env.REACT_APP_IPA_URL}/campaign/type/order`,
      method: 'PATCH',
      data: { increaseOrderId: firstId, decreaseOrderId: secondId },
      expectToken: true,
    }).then(response => response.data),
    '',
  );
};

export const createCampaignType = (name: string): Promise<CampaignTypeResponse> => {
  return trackPromise(
    api({
      url: `${process.env.REACT_APP_IPA_URL}/campaign/type`,
      method: 'POST',
      data: { name },
      expectToken: true,
    }).then(response => response.data),
    '',
  );
};

export const updateCampaignType = ({ id, name }: { id: string; name: string }): Promise<CampaignTypeResponse> => {
  return trackPromise(
    api({
      url: `${process.env.REACT_APP_IPA_URL}/campaign/type/${id}`,
      method: 'PUT',
      data: { name },
      expectToken: true,
    }).then(response => response.data),
    '',
  );
};

export const deleteCampaignType = (id: string): Promise<void> => {
  return trackPromise(
    api({
      url: `${process.env.REACT_APP_IPA_URL}/campaign/type/${id}`,
      method: 'DELETE',
      expectToken: true,
    }).then(response => response.data),
    '',
  );
};
